module.exports = __webpack_public_path__ + "img/calculator-illustration-2.f165e5fe.png";